export const requiredValidation = value => !!value || 'This field is required.'

export const emailValidation = value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Invalid e-mail.'
}

export const minPasswordLengthValidation = value => {
    const length = /(?=.{8,})/
    return length.test(value) || 'Password must contain at least 8 characters'
}

export const noSpacesValidation = value => {
    const pattern = /^\S*$/
    return pattern.test(value) || 'Must field must not include spaces'
}

export const minHandleValidation = val => (val && val.length >= 3) || 'Handle must be at least 3 characters long.'

export const maxHandleValidation = val => (val && val.length <= 50) || 'Handle may not be greater than 50 characters long.'

export const allowedCharactersHandleValidation = val => {
    const reg = /^[a-zA-Z0-9_-]+$/
    return reg.test(val) || 'Handle may only contain alphanumeric characters, dashes &quot;-&quot;, and underscores &quot;_&quot;'
}
